export default __webpack_public_path__ + "assets/svg/download_google.75e5a70ea0a9d3ef3cd59337296d6924.svg";